import React, { Fragment } from 'react';

import {
  SectionHdr,
  Separator,
  TwoColSection,
  ContentHdr,
} from '<sections>/onboarding/styles';
import OnboardingVideos from '../videos';

import WelcomeScreen, { HelpReminder } from '../components/WelcomeScreen';

export default function FlowWelcomeScreen({ onHide, onVideoClick }) {
  const videos = OnboardingVideos.flow;

  return (
    <WelcomeScreen onHide={onHide} sectionLabel={'flow'}>
      <SectionHdr>
        <span className="underline">Flows</span> Overview
      </SectionHdr>

      {videos
        .filter((v) => v.section === 'overview')
        .map((v, idx) => (
          <TwoColSection key={idx} onClick={(e) => onVideoClick(v)}>
            <div className="col">{v.title}</div>
            <div className="video">{v.thumbnail}</div>
          </TwoColSection>
        ))}

      <Separator />
      <HelpReminder />
      <Separator />
      <ContentHdr>
        <span className="underline">How to</span> Create Flows
      </ContentHdr>
      {videos
        .filter((v) => v.section === 'build')
        .map((v, idx) => (
          <TwoColSection key={idx} onClick={(e) => onVideoClick(v)}>
            <div className="col">{v.title}</div>
            <div className="video">{v.thumbnail}</div>
          </TwoColSection>
        ))}

      {videos.filter((v) => v.section === 'concepts').length > 0 && (
        <Fragment>
          <Separator />
          <ContentHdr>
            <span className="underline">Key</span> Concepts
          </ContentHdr>
          {videos
            .filter((v) => v.section === 'concepts')
            .map((v, idx) => (
              <TwoColSection key={idx} onClick={(e) => onVideoClick(v)}>
                <div className="col">{v.title}</div>
                <div className="video">{v.thumbnail}</div>
              </TwoColSection>
            ))}
        </Fragment>
      )}
    </WelcomeScreen>
  );
}
